import React from 'react';
import block from 'bem-cn';

import { PAYMENT_NETWORK, PENDING_TIMER_SECONDS, formatTimer } from 'features/finance/data';
import useCountdown from '../../hooks/useCountdown';

import './WaitingStep.scss';

const b = block('payments-waiting');

const Field = ({ label, value }) => (
  <div className={b('field')}>
    <div className={b('label')}>{label}</div>
    <div className={b('value')}>
      <span className={b('value-text')}>{value}</span>
    </div>
  </div>
);

const WaitingStep = ({
  amount,
  walletAddress = '',
  timerSeconds = PENDING_TIMER_SECONDS,
  locale,
  onExpire,
}) => {
  const secondsLeft = useCountdown(timerSeconds, onExpire);

  return (
    <div className={b()}>
      <h1 className={b('title')}>{locale.balancePurchase}</h1>

      <Field label={locale.paymentNetwork} value={PAYMENT_NETWORK} />
      <Field label={locale.topUpAddress} value={walletAddress} />
      <Field label={locale.topUpAmountUsdt} value={amount} />

      <p className={b('waiting')}>
        {locale.waitingForPayment}
        <br />
        {locale.fundsWillIncrease}
      </p>

      <div className={b('status')}>
        <div className={b('status-label')}>{locale.status}</div>
        <div className={b('status-value')}>{locale.pending}</div>
        <div className={b('status-timer')}>
          {locale.timeLeft}: {formatTimer(secondsLeft)}
        </div>
      </div>
    </div>
  );
};

export default WaitingStep;
